import dayjs from 'dayjs';

export const getAudioMaxDurationSeconds = (
  maxDurationHours: number,
): number => {
  return dayjs.duration(maxDurationHours, 'hours').asSeconds();
};
